module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "back",
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons contentList"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', {
    staticClass: "search",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "material-icons contentList"
  }, [_vm._v("")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('span', [_vm._v("爱乐音悦台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793a89b0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xheader.vue
// module id = 271
// module chunks = 0